// eph5项目域名列表
export const epHlightH5Origins = [
  // 小Bh5
  'https://ep.huolala.cn',
  'https://ep-light-h5-v-pre.huolala.cn',
  'https://ep-light-h5--stable-1-v-pre.huolala.cn',
  'https://ep-light-h5--stable-2-v-pre.huolala.cn',
  'https://ep-light-h5--stable-3-v-pre.huolala.cn',
  'https://ep-light-h5--stable-4-v-pre.huolala.cn',
  'https://ep-light-h5--stable-5-v-pre.huolala.cn',
  'https://ep-light-h5--stable-6-v-pre.huolala.cn',
  'https://ep-light-h5--stable-7-v-pre.huolala.cn',
  'https://ep-light-h5--stable-8-v-pre.huolala.cn',
  'https://ep-light-h5--stable-9-v-pre.huolala.cn',
  // 企业鸿蒙h5
  'https://ep-hm-v.huolala.cn',
  'https://ep-hm-v-pre.huolala.cn',
  'https://ep-hm--stable-1-v-pre.huolala.cn',
  'https://ep-hm--stable-2-v-pre.huolala.cn',
  'https://ep-hm--stable-3-v-pre.huolala.cn',
  'https://ep-hm--stable-4-v-pre.huolala.cn',
  'https://ep-hm--stable-5-v-pre.huolala.cn',
  'https://ep-hm--stable-6-v-pre.huolala.cn',
  'https://ep-hm--stable-7-v-pre.huolala.cn',
  'https://ep-hm--stable-8-v-pre.huolala.cn',
  'https://ep-hm--stable-9-v-pre.huolala.cn',
];


// 企业鸿蒙端的标识
export const EP_HARMONY_OS = 'ep_harmony';

// 小b端H5标识
export const EP_H5_OS = 'ep_h5';

// 小程序端
export const EP_WXA_OS = 'EP_WXA';